import { useCurrentBasket } from '@epmc-mach/accelarator/overrides/app/hooks/use-current-basket'
import { useCurrentCustomer } from '@epmc-mach/accelarator/overrides/app/hooks/use-current-customer'
import { useCustomQuery } from '@salesforce/commerce-sdk-react'

/**
 * Hook to fetch and process translations from Page Designer
 */
export const useCheckCustomerByEmail = () => {
    const { data: basket } = useCurrentBasket()
    const { data: customer } = useCurrentCustomer()

    const { data: customerExists } = useCustomQuery({
        options: {
            method: 'GET',
            customApiPathParameters: {
                apiVersion: 'v1',
                endpointPath: `get-customer-by-email`,
                apiName: 'customer'
            },
            parameters: {
                c_email: basket?.customerInfo?.email,
                c_guest: customer?.isGuest
            }
        },
        rawResponse: false
    }, { enabled: !!basket?.customerInfo?.email && !!customer?.isGuest })

    return customerExists?.found === false;
}